// Configuration for external image assets
import { getConfiguration } from '../services/api';

const imageConfig = {
  // Background image URL will be loaded from configuration with key CMS_BG_IMAGE
  backgroundImage: "",
  
  // Default fallback background image path
  defaultBackgroundImage: "/assets/image-bg.jpg",

  // Watermark image URL will be loaded from configuration with key CMS_WATERMARK
  watermarkImage: "",
  
  // Default fallback watermark image path
  defaultWatermarkImage: "/assets/sports-pattern.png"
};

// Load image configuration from the database
export const loadImageConfig = async (): Promise<void> => {
  // Get background image from configuration table with key CMS_BG_IMAGE
  const bgImage = await getConfiguration('CMS_BG_IMAGE', "");
  imageConfig.backgroundImage = bgImage || imageConfig.defaultBackgroundImage;

  // Get watermark image from configuration table with key CMS_WATERMARK
  const watermarkImage = await getConfiguration('CMS_WATERMARK', "");
  imageConfig.watermarkImage = watermarkImage || imageConfig.defaultWatermarkImage;
};

export default imageConfig; 